export default "__VITE_ASSET__DO0u$hNY__"